import { render, staticRenderFns } from "./GroupOfAccreditationFilesUpload.vue?vue&type=template&id=af524c82&scoped=true"
import script from "./GroupOfAccreditationFilesUpload.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationFilesUpload.vue?vue&type=script&lang=js"
import style0 from "./GroupOfAccreditationFilesUpload.vue?vue&type=style&index=0&id=af524c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af524c82",
  null
  
)

export default component.exports